import { AnalyticsEvent } from "@common/constants/analytics-events";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { trackEvent } from "@lib/analytics";
import { UpgradeCta } from "../Plans/UpgradeCta";

export const ClassesPaywalled = () => {
    useEffectOnce(() => {
        void trackEvent(AnalyticsEvent.UPSELL_CLASSES_OPENED);
    });

    return (
        <div className="flex flex-col w-inherit">
            <UpgradeCta
                title={
                    <>
                        Classes are available on the{" "}
                        <span className="text-blue-600">Plus</span> plan
                    </>
                }
                subtitle="Track income and expenses by product, project or location."
                plan={FLAT_RATE_PLANS.PLUS}
            />
            <img
                src="/images/features/classes.png"
                alt="Premium feature preview"
                width="100%"
            />
        </div>
    );
};
